import { SDKStorage } from "./base";
export class MemoryStorage extends SDKStorage {
    removeAllValues() {
        const length = Object.keys(this.dataStorage).length;
        if (length > 0) {
            Object.keys(this.dataStorage).forEach((data) => delete this.dataStorage[data]);
        }
    }
    getValue(key) {
        return this.dataStorage[key];
    }
    setValue(key, value) {
        this.dataStorage[key] = value;
    }
    removeValue(key) {
        delete this.dataStorage[key];
    }
    constructor(object) {
        super();
        this.dataStorage = object;
    }
}
//# sourceMappingURL=memory-storage.js.map